import React from "react";
import { useLocation } from "react-router-dom";
import { useVideoTutorial } from "../../../contexts/VideoTutorialContext";

const ONBOARDING_ROUTES = new Set([
  "/welcome",
  "/started",
  "/business",
  "/discovery"
]);

const TutorialFab = () => {
  const location = useLocation();
  const { showVideo, openVideo } = useVideoTutorial();

  const shouldShowButton =
    !showVideo && ONBOARDING_ROUTES.has(location.pathname);

  if (!shouldShowButton) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={openVideo}
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2 rounded-full bg-green-12 px-4 py-3 text-white shadow-lg transition-transform hover:scale-105"
    >
      <svg
        className="size-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.868v4.264a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <span className="font-InterMedium text-ft14-20">Watch Tutorial</span>
    </button>
  );
};

export default TutorialFab;
